import React from 'react';
import { cn } from '../../lib/utils';
import { EXPERIENCE } from '../../constants/profileContract';

export function ExperienceSelect({
  value,
  onChange,
  profileType = 'musician',
  className,
}) {
  const levels = EXPERIENCE[profileType] || EXPERIENCE.musician;

  return (
    <div className={cn('space-y-2', className)}>
      {levels.map((level) => {
        const isSelected = value === level.value;
        return (
          <button
            key={level.value}
            type="button"
            onClick={() => onChange(level.value)}
            className={cn(
              'w-full flex items-center justify-between px-5 py-4 rounded-xl border transition-all',
              isSelected
                ? 'bg-amber-500/20 border-amber-500/50'
                : 'bg-[#151515] border-white/[0.08] hover:bg-white/[0.05] hover:border-white/20'
            )}
            data-testid={`experience-${level.value}`}
          >
            <div className="text-left">
              <div className={cn('font-medium', isSelected ? 'text-amber-400' : 'text-white')}>
                {level.label}
              </div>
              <div className="text-xs text-white/40 mt-0.5">{level.desc}</div>
            </div>
            <div
              className={cn(
                'w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all',
                isSelected
                  ? 'border-amber-500 bg-amber-500'
                  : 'border-white/20 bg-transparent'
              )}
            >
              {isSelected && (
                <div className="w-2 h-2 rounded-full bg-black" />
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
}
